function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVictoryReactionsLike = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 352.38 330.08",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M165.59,315.62c2.86-.04,5.74-.06,8.6-.06l96,.04c19.16-.02,43.61-8.64,45.01-26.09,.67-8.31-6.56-17.96-9.49-21.99-.42-.58-.25-1.4,.38-1.75,4.16-2.37,19-6.13,19.3-18.63,.12-5.2-7.68-14.24-11.02-17.43-.59-.56-.46-1.52,.25-1.91,4.66-2.57,20.64-5.89,20.34-18.25-.36-14.61-11.26-18.94-15.37-22.59-.59-.52-.53-1.45,.12-1.9,2.5-1.71,8.13-7.48,13.06-13.74,8.39-10.64,7.56-25.92-2-35.52-5.96-5.98-13.75-10.39-21.82-12.4-5.53-1.36-11.34-2.07-17.27-2.11-13.73-.06-17.21-.07-30.95-.07h-38.79l.12-1.09c.05-.48,.1-.95,.14-1.44,2.37-26.21,25.53-92.86-16.75-104.45,0,0-22.1-8.74-19.84,31.6,.21,3.77,1.13,61.3-58.19,84.89l-2.19,1.95c-2.16,1.92-5.11,3.85-8.74,6.16l-.55,.35-.54-.37c-3.84-2.62-8.37-4.01-13.01-4.01H50.83c-12.37,0-22.51,9.68-23.07,22.03l-13.86,134.04c-.06,.54-.08,1.08-.08,1.63,0,12.74,10.36,23.1,23.09,23.1H102.43c6.91,0,13.41-3.07,17.83-8.43l.52-.63,.72,.4c10.12,5.62,19.88,8.66,42.39,8.66l.09,.99v-.99h1.61Z",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: "23.64px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.42,
    y1: 138.85,
    x2: 121.5,
    y2: 306.96,
    style: {
      strokeMiterlimit: 10,
      strokeWidth: "23.64px"
    }
  }));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVictoryReactionsLike, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Victory_Reactions_Like.06e0b66f.svg";
export { ForwardRef as ReactComponent };